import InterfaceGroupCollection from './InterfaceGroupCollection';

class InterfaceGroupStore {
  capacityCollection = new InterfaceGroupCollection([], { type: 'capacity' });

  icCollection = new InterfaceGroupCollection([], { type: 'ic' });
}

export default new InterfaceGroupStore();
